import React from "react";
import { Outlet } from "react-router-dom";
import LeaveTabs from "./LeaveTabs";

const LeaveLayout = () => {
  return (
    <>
      <LeaveTabs />
      <div className="leave-content-area">
        <Outlet />
      </div>
    </>
  );
};

export default LeaveLayout;
